const PropTypes = require('prop-types');
const React = require('react');

// @constants
const { 
    DEFAULT_SWEEP_FLAG, 
    DEFAULT_AXIS_ROTATION, 
    COMPARATIVE_CIRCLE_LARGE_ZERO_ARC,
    COMPARATIVE_CIRCLE_LARGE_ONE_ARC
} = require('constants/index');

const { COMPARATIVE_CIRCLE_CENTER_X, COMPARATIVE_CIRCLE_RADIUS } = require('constants/comparativeCircle');

class ComparativeCircle extends React.Component {

    polarToCartesian(centerX, centerY, radius, angleInRadian) {
        return {
            x: centerX + (radius * Math.cos(angleInRadian)),
            y: centerY + (radius * Math.sin(angleInRadian))
        };
    }

    /**
     * SVG's arc path is used to create the graph.
     * For more undestanding on arc refer to following links
     * https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
     * https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
     * https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
     */

    describeArcPath(centerX, centerY, radius, startAngle, endAngle){

        const start = this.polarToCartesian(centerX, centerY, radius, startAngle );
        const end = this.polarToCartesian(centerX, centerY, radius, endAngle);

        const largeArcFlag = endAngle - startAngle <= Math.PI ? COMPARATIVE_CIRCLE_LARGE_ZERO_ARC : COMPARATIVE_CIRCLE_LARGE_ONE_ARC;
        const xAxisRotation = DEFAULT_AXIS_ROTATION;
        const sweepFlag = DEFAULT_SWEEP_FLAG;

        const pathData = [
            "M", start.x, start.y, 
            "A", radius, radius, xAxisRotation, largeArcFlag, sweepFlag, end.x, end.y
        ].join(" ");

        return pathData;       
    }

    calculateRatioInRadian() {
        const {baseValue, inputValue} = this.props;
        if (baseValue === 0) {
            return 0;
        } 
        const valueInRadian = (inputValue / baseValue ) * Math.PI * 2;
        return valueInRadian;
    }

    render() {
        const { extraClass, width } = this.props;
        const centerX = COMPARATIVE_CIRCLE_CENTER_X;
        const centerY = centerX;
        const circleRadius = COMPARATIVE_CIRCLE_RADIUS;
        const boxSize = centerX * 2;
        const radianThreeSixtyDegree = Math.PI * 2;
        const radianNintyDegree = Math.PI / 2;

        const valueRatioInRadian = this.calculateRatioInRadian();

        const startAngleInRadian = 0;
        //When arc angle is 360degree start and end point becomes same. Hence following correction is requried
        const endAngleInRadian = valueRatioInRadian < radianThreeSixtyDegree ? valueRatioInRadian : radianThreeSixtyDegree - 0.0001;

        const rotatedStartAngleInRadian = startAngleInRadian - radianNintyDegree;
        const rotatedEndAngleInRadian = endAngleInRadian - radianNintyDegree;

        const pathData = this.describeArcPath(centerX, centerY, circleRadius, rotatedStartAngleInRadian, rotatedEndAngleInRadian);

        return (
            <div className={`comparative-circle ${extraClass}`}>
                <svg viewBox={`0 0 ${boxSize} ${boxSize}`}>
                    <circle 
                        className="comparative-circle-base" 
                        cx={centerX} 
                        cy={centerY} 
                        r={circleRadius} 
                        fill="none" 
                        stroke="#666666" 
                        strokeWidth={width} 
                        strokeOpacity="0.5"
                    />
                    <path 
                        className="comparative-circle-value" 
                        d={pathData} fill="none" 
                        stroke="#000000" 
                        strokeWidth={width}
                    />
                </svg>
            </div>
        );
    }
}

ComparativeCircle.propTypes = {
    baseValue: PropTypes.number.isRequired,
    extraClass: PropTypes.string,
    inputValue: PropTypes.number.isRequired,
    width: PropTypes.number
};

ComparativeCircle.defaultProps = {
    baseValue: 0,
    extraClass: '',
    inputValue: 0,
    width: 20
}

module.exports = ComparativeCircle;
